import { z } from 'zod';
import { datetime } from './commons';
// ========================================================
// Enum
// ========================================================
export var TiersPersonnaliteJuridique;
(function (TiersPersonnaliteJuridique) {
    TiersPersonnaliteJuridique["PHYSIQUE"] = "PHYSIQUE";
    TiersPersonnaliteJuridique["MORALE"] = "MORALE";
})(TiersPersonnaliteJuridique || (TiersPersonnaliteJuridique = {}));
export var TiersTypeFamille;
(function (TiersTypeFamille) {
    TiersTypeFamille["TIERS"] = "TIERS";
    TiersTypeFamille["ASSOCIATION"] = "TIERS_ASSOCIATION";
    TiersTypeFamille["COMMUNE"] = "TIERS_COMMUNE";
    TiersTypeFamille["ENTREPRENEUR_INDIVIDUEL"] = "TIERS_ENTREPRENEUR_INDIVIDUEL";
    TiersTypeFamille["ENTREPRISE"] = "TIERS_ENTREPRISE";
    TiersTypeFamille["EPCI"] = "TIERS_EPCI";
    TiersTypeFamille["ETABLISSEMENT_FORMATION"] = "TIERS_ETABLISSEMENT_FORMATION";
    TiersTypeFamille["PARTICULIER"] = "TIERS_PARTICULIER";
})(TiersTypeFamille || (TiersTypeFamille = {}));
export var TiersStatus;
(function (TiersStatus) {
    TiersStatus["TEMPORARY"] = "TEMPORARY";
    TiersStatus["SUPPORTED"] = "SUPPORTED";
    TiersStatus["BLOCKED"] = "BLOCKED";
    TiersStatus["OBSOLETE"] = "OBSOLETE";
    TiersStatus["TRANSMITTED"] = "TRANSMITTED";
    TiersStatus["MERGED"] = "MERGED";
})(TiersStatus || (TiersStatus = {}));
export const TiersValidStatuses = [TiersStatus.SUPPORTED, TiersStatus.BLOCKED, TiersStatus.OBSOLETE];
// ========================================================
// Tiers from API zod validation
// we use zod to validate external data into the domain
// ========================================================
const TiersSitutations = z.object({
    afnor: z
        .object({
        LigneCinq: z.string().optional(),
        LigneSix: z.string().optional(),
    })
        .optional(),
    geographique: z
        .object({
        PointRemise: z.string().optional(),
        Complement: z.string().optional(),
        NomVoie: z.string().optional(),
        MentionDistribution: z.string().optional(),
        CodePostal: z.string().optional(),
        Localite: z
            .object({
            value: z.string(),
        })
            .optional(),
        Pays: z
            .object({
            value: z.string(),
        })
            .optional(),
    })
        .optional(),
});
const TiersRepresentants = z.object({
    title: z.string().optional(),
});
export const TiersSchema = z.object({
    id: z.string(),
    SIRET: z
        .object({
        NIC: z.string(),
        SIREN: z.string(),
    })
        .optional(),
    title: z.string(),
    active: z.boolean(),
    date: datetime,
    reference: z.string(),
    version: z.string(),
    enseigne: z.string().optional(),
    formeJuridique: z
        .object({
        href: z.string(),
        title: z.string(),
    })
        .optional(),
    famille: z.object({
        title: z.string(),
        expand: z
            .object({
            typeFamille: z.nativeEnum(TiersTypeFamille),
            personnaliteJuridique: z.nativeEnum(TiersPersonnaliteJuridique),
        })
            .optional(),
    }),
    situations: z.array(TiersSitutations),
    representants: z.array(TiersRepresentants),
    individu: z
        .object({
        Noms: z.object({
            NomUsage: z.string(),
            NomFamille: z.string().optional(),
        }),
        Prenoms: z.object({
            PrenomUsuel: z.string(),
        }),
        Naissance: z
            .object({
            DateNaissance: z.string().optional(),
            LieuNaissance: z
                .object({
                Localite: z
                    .object({
                    value: z.string(),
                })
                    .optional(),
            })
                .optional(),
        })
            .optional(),
    })
        .optional(),
    telephones: z
        .array(z.object({
        TYPE: z.string().optional(),
        value: z.string(),
    }))
        .optional(),
    courriels: z
        .array(z.object({
        TYPE: z.string().optional(),
        value: z.string(),
    }))
        .optional(),
    status: z.nativeEnum(TiersStatus),
    gestionDemandesApprenants: z.boolean().optional(),
    sansSIRET: z
        .object({
        valeur: z.boolean(),
    })
        .optional(),
    features: z
        .object({
        organismeFormation: z.boolean().optional(),
    })
        .optional(),
});
export const TiersPublicSettingsSchema = z.object({
    displayTiersReferentUsager: z.object({
        active: z.boolean(),
    }),
});
export const ReferentSchema = z.object({
    displayName: z.string(),
    title: z.string().optional(),
    organizationUnitLabel: z.string().optional(),
    businessUnitLabel: z.string().optional(),
    divisionLabel: z.string().optional(),
    departmentLabel: z.string().optional(),
    phoneNumbers: z.array(z.string()).optional(),
    emails: z.array(z.string()).optional(),
});
//# sourceMappingURL=tiers.js.map